import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

// Assinatura com dedo/caneta/rato (pointer events). onChange recebe dataURL PNG ou "" quando vazio.
export default function SignaturePad({ onChange, testId = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => {
    e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true;
    const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke();
    if (empty) setEmpty(false);
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (!empty) onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange("");
  };

  return (
    <div className="space-y-2">
      <div className="relative rounded-xl bg-white border-2 border-dashed border-slate-300">
        <canvas
          ref={ref} data-testid={testId}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          className="w-full h-40 touch-none cursor-crosshair rounded-xl"
        />
        {empty && <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-slate-400 text-sm">Assine aqui com o dedo ou caneta</div>}
      </div>
      <button type="button" data-testid={`${testId}-clear`} onClick={clear}
        className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-200 transition-colors">
        <Eraser className="w-3.5 h-3.5" /> Limpar assinatura
      </button>
    </div>
  );
}
